import React from 'react'
import PropTypes from 'prop-types'
import ReactTooltip from 'react-tooltip'
import styled from 'styled-components'
import ProvisionalSvg from '../../static/images/icon_certification_provisional.svg'
import StandardSvg from '../../static/images/icon_certification_standard.svg'
import { getUserCertificationMarkerTooltipText } from '../../utils/user'

const ProvisionalCertification = styled.img.attrs({
  src: ProvisionalSvg
})`
  margin-left: 5px !important;
  width: 15px !important;
  height: 15px !important;
  position: relative !important;
  top: 2px !important;
`

const StandardCertification = styled.img.attrs({
  src: StandardSvg
})`
  margin-left: 5px !important;
  width: 15px !important;
  height: 15px !important;
  position: relative !important;
  top: 2px !important;
`

class UserName extends React.Component {
  componentDidUpdate() {
    this.props.rebuild && ReactTooltip.rebuild()
  }

  render() {
    const { activeCertifications, children, userId } = this.props

    return (
      <React.Fragment>
        {children}
        {activeCertifications.length > 0 && (
          <React.Fragment>
            <ReactTooltip
              className="user-certification"
              id={`${userId}-cert-tooltip`}
              effect="solid"
            >
              <div>
                <strong>Certified</strong>
              </div>
              {getUserCertificationMarkerTooltipText(activeCertifications)}
            </ReactTooltip>
            {activeCertifications.some(c => c.level === 'standard') ? (
              <StandardCertification
                data-for={`${userId}-cert-tooltip`}
                data-tip="tip"
              />
            ) : (
              <ProvisionalCertification
                data-for={`${userId}-cert-tooltip`}
                data-tip="tip"
              />
            )}
          </React.Fragment>
        )}
      </React.Fragment>
    )
  }
}

UserName.propTypes = {
  children: PropTypes.object.isRequired,
  activeCertifications: PropTypes.array.isRequired,
  userId: PropTypes.string.isRequired,
  rebuild: PropTypes.bool
}

export default UserName



// WEBPACK FOOTER //
// ./src/components/mini/UserName.js